import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { AuthenticationState, UserInterface } from "../../interfaces/users";
import { api } from "../../config";
import { Button, Select, Table } from "antd";
import { SeniorityInterface } from "../../interfaces/seniority";
import { updateManyUserInfo } from "../../utils";
import { toast } from "react-toastify";
import { useState } from "react";

export const Assemblers = () => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const {
    data: usersData,
    isFetching: isFetchingUsers,
    refetch: refetchUsers,
  } = useQuery<UserInterface[]>("users", () =>
    api(token).get(`/users?moduleName=ASSEMBLE_APP&permission=USER`)
  );

  const {
    data: senioritiesData,
  } = useQuery<SeniorityInterface[]>("seniority", () =>
    api(token).get(`/seniority`)
  );

    const {
      data: leadersData,
    } = useQuery<UserInterface[]>("users-leader", () =>
      api(token).get(`/users?moduleName=ASSEMBLE&permission=ADMIN,USER`)
    ); 

  const [usersSeniorities, setUsersSeniorities] = useState<
    {
      id: number;
      seniorityId: number;
    }[]
  >([]);

  const [usersLeader, setUsersLeader] = useState<
    {
      id: number;
      leaderId: number;
    }[]
  >([]);

  const [loading, setLoading] = useState(false);

  const handleSaveSUsersSeniority = async () => {
    setLoading(true);
    try {
      const updatedUsers = await updateManyUserInfo(token, usersSeniorities);
      if (usersLeader.length) {
        await updateManyUserInfo(token, usersLeader);
      }
      if (updatedUsers) {
        refetchUsers();
        setUsersSeniorities([]);
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao atualizar o usuário");
    } finally {
      setLoading(false);
    }
  };

  const updateUserSeniority = (
    userId: number,
    newSeniorityId: number
  ): void => {
    if (userId === null || newSeniorityId === null) return;

    const existingUser = usersSeniorities.find((user) => user.id === userId);

    if (existingUser?.seniorityId === newSeniorityId) return;

    setUsersSeniorities(
      existingUser
        ? usersSeniorities.map((user) =>
            user.id === userId
              ? { id: userId, seniorityId: newSeniorityId }
              : user
          )
        : [...usersSeniorities, { id: userId, seniorityId: newSeniorityId }]
    );
  };

const updateUserLeader = (
    userId: number,
    newLeaderId: number
  ): void => {
    if (userId === null || newLeaderId === null) return;

    const existingUser = usersLeader.find((user) => user.id === userId);

    if (existingUser?.leaderId === newLeaderId) return;

    setUsersLeader(
      existingUser
        ? usersLeader.map((user) =>
            user.id === userId
              ? { id: userId, leaderId: newLeaderId }
              : user
          )
        : [...usersLeader, { id: userId, leaderId: newLeaderId }]
    );
  };

  const defaultColumns = [
    {
      title: "Nome",
      dataIndex: "fullName",
      width: "30%",
      editable: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "20%",
    },
    {
      title: "Senioridade",
      dataIndex: "grade",
      render: (_: any, record: any) =>
        senioritiesData ? (
          <>
            <Select
              key={record.id}
              onChange={(seniorityId: number) =>
                updateUserSeniority(record.id, seniorityId)
              }
              defaultValue={
                usersSeniorities?.find((user) => user.id === record.id)
                  ?.seniorityId ||
                record.seniority?.id ||
                null
              }
              style={{ width: 120 }}
              placeholder={"Selecione a senioridade"}
            >
              {senioritiesData.map((seniority) => (
                <Select.Option value={seniority.id}>
                  {seniority.name}
                </Select.Option>
              ))}
            </Select>
          </>
        ) : null,
    },
    {
       title: "Líder",
      dataIndex: "leaderId",
      render: (_: any, record: any) =>
        leadersData ? (
          <>
            <Select
              key={record.id}
              onChange={(leaderId: number) =>
                updateUserLeader(record.id, leaderId)
              }
              defaultValue={
                usersData?.find((user) => user.id === record.id)
                  ?.leaderId ||
                record.leader?.id ||
                null
              }
              style={{ width: 240 }}
              placeholder={"Selecione a Líder"}
            >
              {leadersData.map((leader) => (
                <Select.Option value={leader.id}>
                  {leader.fullName}
                </Select.Option>
              ))}
            </Select>
          </>
        ) : null,
    }
  ];
  return (
    <div>
      <Table
        loading={isFetchingUsers}
        bordered
        dataSource={usersData}
        columns={defaultColumns}
        pagination={{ position: ["bottomCenter"] }}
      />
      <div className="flex justify-end">
        <Button
          type="primary"
          onClick={handleSaveSUsersSeniority}
          loading={loading}
          disabled={!usersSeniorities.length && !usersLeader.length}
        >
          Salvar
        </Button>
      </div>
    </div>
  );
};
